import React from 'react';
import { Link } from 'react-router-dom';
import { Modal, ModalHeader, ModalBody, Button } from 'reactstrap';

export const ModalInactiveUserExists = ({ isOpen, toggle }) => {
    return (
        <Modal isOpen={isOpen} toggle={toggle} centered size='md' className='close-circle'>
            <ModalHeader toggle={toggle} className='justify-content-center border-0 pb-0' />
            <ModalBody className='text-center'>
                <p className='mb-4'>
                    This user already exists in our system and is set to inactive. To reactivate your user under this email, please contact us{' '}
                    <Link to="/contact-us" className="text-primary font-weight-semibold" onClick={toggle}>
                        here
                    </Link>
                    .
                </p>
                <Button color='green-light' size='sm' onClick={toggle}>I Understand</Button>
            </ModalBody>
        </Modal>
    );
};
